<template>
  <div>
    <v-card-title class="headline">Guidelines</v-card-title>
    <v-card-text class="py-0">
      <v-flex xs12>
        <v-autocomplete v-model="selected" :items="itemsForAutoComplete" box chips                              
                label="Select Guideline" item-text="GuideineName">
                <template v-slot:selection="data">
                  <v-list-tile-content>
                      <v-list-tile-title v-html="data.item.GuidelineName"></v-list-tile-title>
                      <v-list-tile-sub-title v-html="data.item.GuidelineLongName"></v-list-tile-sub-title>
                    </v-list-tile-content>
                </template>
                <template v-slot:item="data">
                  <template v-if="typeof data.item !== 'object'">
                    <v-list-tile-content v-text="data.item"></v-list-tile-content>
                  </template>
                  <template v-else>
                    <v-list-tile-content>
                      <v-list-tile-title v-html="data.item.GuidelineName"></v-list-tile-title>
                      <v-list-tile-sub-title v-html="data.item.GuidelineLongName"></v-list-tile-sub-title>
                    </v-list-tile-content>
                  </template>
                </template>

        </v-autocomplete>
      </v-flex>
    </v-card-text>
    <div class="text-xs-center caption pb-4 pt-3">
      <template v-if="items.length > 0">
        {{ items.length}} {{ items.length > 1 ? 'guidelines' : 'guideline' }} available
      </template>
    </div>
  </div>
</template>

<script>
  import {
    createNamespacedHelpers,
  } from 'vuex'
  const {
    mapGetters,
    mapActions,
  } = createNamespacedHelpers('guidelines')
  const authenticate = createNamespacedHelpers('authenticate')

  export default {
    props: ['selectedGuidelines', 'selectedMedia', 'shouldSetDefaultSelection', 'preConfig'],
    mounted() {
      if (this.Guidelines == null || this.Guidelines.length == 0) {
        this.getGuidelines().then(() => this.getItemsForDropdown())
      } else {
        this.getItemsForDropdown()
      }
    },
    data() {
      return {
        items: [],
        itemsWithCategory: [],
        itemsForAutoComplete: [
        ],
        selected: {
          GuidelineName: '',
          GuidelineLongName: '',
          Category: '',
        },
        counter: 0,
      }
    },
    computed: {
      ...mapGetters({
        'Guidelines': 'guidelineOfCurrentTenant',
      }),
      ...authenticate.mapGetters(['currentTenant']),
      hint() {
        if (this.items.length == 0) return 'The media type selected has no guidelines'
        return this.selected && this.selected.GuidelineLongName || ''
      },
    },
    watch: {
      selected() {
        this.$emit('onGuidelineSelect', this.selected)
      },
      selectedMedia() {        
        if (this.Guidelines == null || this.Guidelines.length == 0) {
          this.getGuidelines(this.currentTenant.id).then(() => this.getItemsForDropdown())
        } else {
          this.getItemsForDropdown()
        }
      },
      selectedGuidelines() {
        if (this.selectedGuidelines != null && this.selectedGuidelines.length > 0 && this.selectedGuidelines[0] !=
          null && this.selectedGuidelines[0].GuidelineName != '') {
          this.selected = this.items.find(x => x.GuidelineName == this.selectedGuidelines[0].GuidelineName)
        }
      },
      preConfig() {
        if(this.preConfig != null) {
          this.getItemsForDropdown()
        }
      },
    },
    methods: {
      ...mapActions(['getGuidelines']),
      getItemsForDropdown() {       
        var matchedGuidelines = []
        if(this.preConfig == null) {
          matchedGuidelines = this.Guidelines.filter(x => this.decideGuidelineFeasibleForMedia(x, this.selectedMedia))
        } else {
          let matchedConfig = this.preConfig.filter(x => x.MediaType == this.selectedMedia)
          if(matchedConfig != null && matchedConfig.length > 0) {
            let codes = matchedConfig[0].Guidelines
            matchedGuidelines = this.Guidelines.filter(x => codes.indexOf(x.GuidelineName) >= 0)
          }
        }
        
        this.items = matchedGuidelines.map(m => {
          return {
            Id: m.Id,
            GuidelineName: m.GuidelineName,
            GuidelineLongName: m.GuidelineLongName,
            Category: m.Category != null ? m.Category : 'Others',
          }
        })

        var itemGroups = []
        this.items.forEach(gl => {
          var matched = itemGroups.find(x => x.Category == gl.Category)
          if(!matched) {
            matched = {
              Category: gl.Category,
              Guidelines: [gl],
            }
            itemGroups.push(matched)
            itemGroups.sort((a, b) => {
              if (a.Category == 'Others') {
                return -1
              }
              if (b.Category == 'Others') {
                return 1
              }
              return a.Category <= b.Category ? -1 : 1
            })

          } else {
            matched.Guidelines.push(gl)
            matched.Guidelines.sort((a, b) => {              
              return a.GuidelineName <= b.GuidelineName ? -1 : 1
            })
          }
        })
        this.itemsWithCategory = itemGroups

        var categoryForUI = []
        this.itemsWithCategory.forEach(gc => {
          categoryForUI.push({ header: gc.Category })

          gc.Guidelines.forEach(g => {
            categoryForUI.push(g)
          })

          categoryForUI.push({ divider: true },)
        })

        this.itemsForAutoComplete = categoryForUI
        
        if (this.items.length > 0) {
          if (this.selectedGuidelines != null && this.selectedGuidelines.length > 0 && this.selectedGuidelines[0] !=
            null && this.selectedGuidelines[0].GuidelineName != '') {
            this.selected = this.items.find(x => x.GuidelineName == this.selectedGuidelines[0].GuidelineName)
          } else {
            if (this.shouldSetDefaultSelection) {
              this.selected = this.items[0]
            }
          }
        }
      },
      decideGuidelineFeasibleForMedia(guideline, media) {
        if (media == '' || media == undefined || media == null) {
          return false
        }
        let feasibleMedias = guideline.Medias.map(x => x.Name)
        return (feasibleMedias.indexOf(media) >= 0) || (feasibleMedias.some(x => x.indexOf(media) >= 0))
      },
    },
  }
</script>